import React from 'react'
import { FaKeybase } from 'react-icons/fa'

export const Social = ({ social, disabledClass, socialClasses, user }) => {
  return !social ? null : (
    <div className={socialClasses}>
      {social.phonenumber ? (
        <a
          aria-label="make a call to user's phone number"
          style={{ color: 'black' }}
          href={
            'tel:' + !social.phonenumber ? social.whatsapp : social.phonenumber
          }>
          <i className="text-color fa fa-phone" />
        </a>
      ) : (
        <a
          aria-label="make a call to user's phone number"
          className={disabledClass}
          href="#">
          <i className="text-color fa fa-phone" />
        </a>
      )}
      {social.whatsapp ? (
        <a
          aria-label="Chat with user on whatsapp directly"
          rel="noreferrer"
          href={'https://api.whatsapp.com/send?phone=' + social.whatsapp}>
          <i className="fa fa-whatsapp whatsapp" />
        </a>
      ) : (
        <a
          aria-label="Chat with user on whatsapp directly"
          className={disabledClass}
          href="#">
          <i className="fa fa-whatsapp whatsapp" />
        </a>
      )}
      {social.telegram ? (
        <a
          aria-label="Chat with user on telegram directly"
          href={'https://t.me/' + social.telegram}>
          <i className="fa fa-telegram telegram" />
        </a>
      ) : (
        <a
          aria-label="Chat with user on telegram directly"
          className={disabledClass}
          href="#">
          <i className="fa fa-telegram telegram" />
        </a>
      )}
      {social.twitter ? (
        <a
          aria-label="Visit user's twitter profile"
          href={'https://twitter.com/' + social.twitter}>
          <i aria-disabled className="fa fa-twitter twitter" />
        </a>
      ) : (
        <a
          aria-label="Visit user's twitter profile"
          className={disabledClass}
          href="#">
          <i aria-disabled className="fa fa-twitter twitter" />
        </a>
      )}
      {social.facebook ? (
        <a aria-label="Visit user's facebook profile" href={social.facebook}>
          <i className="fa fa-facebook facebook" />
        </a>
      ) : (
        <a
          aria-label="Visit user's facebook profile"
          className={disabledClass}
          href="#">
          <i className="fa fa-facebook facebook" />
        </a>
      )}
      {social.instagram ? (
        <a
          aria-label="Visit user's instagram profile"
          href={'https://instagram.com/' + social.instagram}>
          <i className="fa fa-instagram insta" />
        </a>
      ) : (
        <a
          aria-label="Visit user's instagram profile"
          className={disabledClass}
          href="#">
          <i className="fa fa-instagram insta" />
        </a>
      )}
      {social.snapchat ? (
        <a
          aria-label="Add user to your snapchat"
          href={'https://www.snapchat.com/add/' + social.snapchat}>
          <i className="fa fa-snapchat snapchat" />
        </a>
      ) : (
        <a
          aria-label="Add user to your snapchat"
          className={disabledClass}
          href="#">
          <i className="fa fa-snapchat snapchat" />
        </a>
      )}
      {social.github ? (
        <a
          aria-label="Visit user's github profile"
          style={{ color: 'black' }}
          href={'https://github.com/' + social.github}>
          <i className="text-color fa fa-github" />
        </a>
      ) : (
        <a
          aria-label="Visit user's github profile"
          className={disabledClass}
          href="#">
          <i className="text-color fa fa-github" />
        </a>
      )}
      {social.keybase ? (
        <a
          aria-label="Visit user's keybase profile"
          style={{ color: 'black' }}
          href={'https://keybase.io/' + social.keybase}>
          <FaKeybase style={{ margin: '-2px 0 0 0' }} className="text-color" />
        </a>
      ) : (
        <a
          aria-label="Visit user's keybase profile"
          className={disabledClass}
          href="#">
          <FaKeybase style={{ margin: '-2px 0 0 0' }} className="text-color" />
        </a>
      )}
    </div>
  )
}

Social.displayName = 's'

export default Social
